webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
function injectStyle (ssrContext) {
  __webpack_require__("4fvv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+aSA":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"highload-service-backend-customizations\">Highload service backend customizations</h4>\n<p><strong>Customer:</strong> Huge telecommunications operator (SPBTV client)</p>\n<p><strong>Description:</strong> Customer wanted to add additional info about channels off-airs to main company service backend and ​client devices application.</p>\n<p><strong>Languages:</strong> Ruby</p>\n<p><strong>Tools:</strong> PORO, SNMP, Memcache</p>\n<p><strong>Position:</strong> Software Developer</p>\n<p><strong>Role:</strong></p>\n<ul>\n<li>Added several modules for receiving off-air schedules from channel apis and checking streamers availability over SNMP</li>\n<li>Coded a server subsystem including off-air info for main cached service data</li>\n</ul>\n";

/***/ }),

/***/ "+fsv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/+mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = function state() {
  return {
    editorEntities: []
  };
};

var mutations = {
  setEditing: function setEditing(state, entity) {
    state.editorEntities.push(entity);
  }
};

var actions = {
  setEditing: function setEditing(context, entity) {
    context.commit('setEditing', entity.toString());
  }
};

var getters = {
  isEditing: function isEditing(state) {
    return function (entity) {
      return state.editorEntities.includes(entity);
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
  namespaced: true
});

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("sqiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__("/CDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__("GnGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase__ = __webpack_require__("peot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startcase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(v).map(function (k) {
      return toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return toString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    field = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["c" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    // Build the caption
    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // Build the thead
    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["f" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["f" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    // Build the tfoot
    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["f" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["f" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    // Add static Top Row slot
    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the body rows
    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];
      // For Each Row
      var tds = fields.map(function (field) {
        // Foe Each field in the row
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });
      // Assemble and add the row
      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));
      // Row Details slot
      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot
    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', {}, rows);

    // Return the assembled table
    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0.beta.10 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["a" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.fields) === 'object' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(k) });
        });
      }
      // Ensure we have a unique array of fields and that they have labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: __WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});

/***/ }),

/***/ "06tE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0WqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-article row"},[(_vm.bzData.title)?_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.localized('title')))])]):_vm._e(),_vm._l((_vm.children),function(child){return _c(_vm.tagByModel(child[0]),{key:_vm.compoundKey.apply(void 0, child),tag:"component",attrs:{"id":child[1]}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "178r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4fvv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4rkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var BzTreeItem = {
  props: {
    id: String
  },
  computed: {
    bzData: function bzData() {
      return this.$store.getters['bzTree/getLeaf'](this.modelName, this.id);
    },
    children: function children() {
      return this.bzData.children;
    },
    modelName: function modelName() {
      var tagname = this.$data.modelTag || this.$options._componentTag;
      return this.$store.getters['bzTree/modelByTag'](tagname);
    },
    dataKey: function dataKey() {
      return this.compoundKey(this.modelName, this.id);
    },
    locale: function locale() {
      return this.$store.getters['localization/getLocale'](this.dataKey);
    },
    level: function level() {
      return this.$store.getters['bzTree/getLevel'](this.modelName, this.id);
    }
  },
  methods: {
    tagByModel: function tagByModel(model) {
      return this.$store.getters['bzTree/tagByModel'](model);
    },
    compoundKey: function compoundKey(model, id) {
      return model + '_' + id;
    },
    localized: function localized(field) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.bzData[field]) === 'object') {
        return this.bzData[field][this.locale];
      } else {
        return this.bzData[field];
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (BzTreeItem);
/*
.article.row
  .col-12.paragraph
    .row
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[0]"
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[1]"
      .col-md-4.col-sm-12.paragraph
        .row
          .col-12.text v-html="texts[2]"
.article.row
  .col-12.paragraph
    h3 Recently Completed Projects
    .row
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[3]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[4]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[5]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[6]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[7]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[8]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[9]"
      .col-12.paragraph
        .row
          .col-12.text v-html="texts[10]"
*/

/***/ }),

/***/ "5oOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-text col-12",class:_vm.customClass,domProps:{"innerHTML":_vm._s(_vm.localized('html'))}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5wyn":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"sudprof-com\">Sudprof.com</h4>\n<p><strong>Customer:</strong> Non-profitable trade-union marine organization</p>\n<p><strong>Description:</strong> Corporate website, Ruby-based CMS</p>\n<p><strong>Languages:</strong> Ruby</p>\n<p><strong>Tools:</strong> Ruby on Rails, SuckerPunch, Celluloid, Git, Gitlab, Rspec, Slim, Closure Tree, MySQL, RMagick, Omniauth, FFMpeg, Sass, Angular JS, Highcharts, CoffeeScript, Pundit, ffmpeg-thumbnailer, NewRelic RPM</p>\n<p><strong>Position:</strong> Pet project, full-stack Software Developer</p>\n<p><strong>What was made:</strong></p>\n<ul>\n<li>Angular frontend</li>\n<li>Wrote markup with Slim</li>\n<li>Created tree-like entity structure of CMS (using Closure tree and STI reversed structure)</li>\n<li>User authentication system (Device + Omniauth)</li>\n<li>Coded authorization system using Pundit</li>\n<li>Added user groups and groups hierarchy</li>\n<li>Coded assets uploading and processing system using Carrierwave, RMagick, FFMpeg and ffmpeg-thumbnailer</li>\n<li>Coded Carrierwave plugin for delayed processing using SuckerPunch and Celluloid</li>\n<li>Coded Statistics system using Impressionist gem and Highcharts + AngularJS on client-side</li>\n<li>Created user comments subsystem</li>\n<li>Developed administration console with comments and multi-group notes tracking</li>\n<li>Developed multiple user-role based js-tours with many descriptions</li>\n<li>Made several Rails perfomance and memory customizations</li>\n</ul>\n<p><strong>Status:</strong> It was working fine for more than 7 years. Several annual updates had been done.</p>\n";

/***/ }),

/***/ "6IIv":
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\">\n    <img class=\"img-thumbnail rounded-circle\" src='https://ru.gravatar.com/userimage/17702696/3895c416ee56759755edd2e23d4ee294.jpg?size=200'/>\n</div>\n";

/***/ }),

/***/ "6Mx6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6rxZ":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"mdl\">MDL</h4>\n<p><strong>Customer:</strong> Cryptocurrency / Smart contracts project</p>\n<p><strong>Description:</strong> Ecosystem designed to facilitate the talent sourcing market. Insightful expertise in both IT technologies and the entertainment industry that allows to bring the most efficient and effective medium for collaboration between artists, bookers, and brands.</p>\n<p><strong>Languages:</strong>​ Ruby</p>\n<p><strong>Position:</strong> ​Software Developer</p>\n<p><strong>Role:​</strong></p>\n<ul>\n<li>MvP</li>\n<li>Authentication</li>\n<li>Api</li>\n</ul>\n";

/***/ }),

/***/ "8TBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzArticle_vue__ = __webpack_require__("pROM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a63c46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzArticle_vue__ = __webpack_require__("0WqY");
function injectStyle (ssrContext) {
  __webpack_require__("PAa6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76a63c46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a63c46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzArticle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__ = __webpack_require__("cxWw");
function injectStyle (ssrContext) {
  __webpack_require__("6Mx6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AXQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzEditor_vue__ = __webpack_require__("zoEP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51c67666_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzEditor_vue__ = __webpack_require__("ic8n");
function injectStyle (ssrContext) {
  __webpack_require__("p4RR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51c67666"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51c67666_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B27q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__ = __webpack_require__("4rkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzText__ = __webpack_require__("FlH3");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bz-paragraph',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__["a" /* default */]],
  components: { BzText: __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzText__["a" /* default */] },
  methods: {
    columnsClass: function columnsClass() {
      var columns = this.bzData && this.bzData.style && this.bzData.style.columns;
      if (columns !== undefined) {
        var compoundClass = [];
        columns.large && compoundClass.push('col-lg-' + columns.large);
        columns.middle && compoundClass.push('col-md-' + columns.middle);
        columns.small && compoundClass.push('col-sm-' + columns.small);
        if (typeof columns === 'number') {
          compoundClass.push('col-' + columns);
        }
        return compoundClass.join(' ');
      }
      return 'col-12';
    },
    titleTag: function titleTag() {
      var level = (this.level || 3) + 1;
      return 'h' + level;
    },
    titleStyle: function titleStyle() {
      var titleStyle = this.bzData && this.bzData.style && this.bzData.style.title;
      return titleStyle;
    }
  }
});

/***/ }),

/***/ "EHTN":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"sudprof-com\">Sudprof.com</h4>\n<p><strong>Заказчик:</strong> Некоммерческая профсоюзная судостроительная организация</p>\n<p><strong>Описание:</strong> Корпоративный вебсайт, самописная CMS</p>\n<p><strong>Языки:</strong> Ruby</p>\n<p><strong>Инструменты:</strong> Ruby on Rails, SuckerPunch, Celluloid, Git, Gitlab, Rspec, Slim, Closure Tree, MySQL, RMagick, Omniauth, FFMpeg, Sass, Angular JS, Highcharts, CoffeeScript, Pundit, ffmpeg-thumbnailer, NewRelic RPM</p>\n<p><strong>Позиция:</strong> ​Pet-проект, full-stack разработчик</p>\n<p><strong>Реализовано:</strong></p>\n<ul>\n<li>Фронтенд на Angular</li>\n<li>Slim разметка</li>\n<li>Однородная древовидная структура CMS (использовался Closure Tree паттерн и обратный STI для данных)</li>\n<li>Система аутентификации (Devise + Omniauth)</li>\n<li>Система авторизации на Pundit</li>\n<li>Иерархическая система прав доступа</li>\n<li>Система загрузки и backend обработки загрузок на Carrierwave, RMagick, FileMagic, FFMpeg и ffmpeg-thumbnailer</li>\n<li>Отложенная обработка на Celluloid и SuckerPunch</li>\n<li>Система сбора и отображения статистики на Impressionist + Highcharts.js</li>\n<li>Подсистема комметариев</li>\n<li>Админ-панель с трекингом сообщений и активности пользователей</li>\n<li>Обзорные туры по сайту</li>\n</ul>\n<p><strong>Статус:</strong> Проект прекратил существование. Полностью поддерживал его в течение 7 лет. Несколько раз обновлял, добавляя разные функции, переезжая с Rails 2.3 на Rails 4 и 5</p>\n";

/***/ }),

/***/ "EodU":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"-api\">Кастомизация высоконагруженного API</h4>\n<p><strong>Заказчик:</strong> Крупный российский оператор связи (клиент SPBTV)</p>\n<p><strong>Описание:</strong> Добавление функциональности по кэшированию и обновлению информации о сервисных периодах каналов на главном high-load бэкенде приложения.</p>\n<p><strong>Языки:</strong> Ruby</p>\n<p><strong>Инструменты:</strong> PORO, SNMP, Memcache</p>\n<p><strong>Позиция:</strong> Разработчик</p>\n<p><strong>Роль:</strong></p>\n<ul>\n<li>Добавил несколько модулей для обслуживания клиентов при отсутствии сигнала от стриммеров каналов, получая данные об отсутствии стримов по SNMP</li>\n<li>Сделал подсистему, обновляющую основной кэш приложения, добавляя туда информацию о сервисных периодах</li>\n</ul>\n";

/***/ }),

/***/ "FlH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzText_vue__ = __webpack_require__("OA+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8cd51d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzText_vue__ = __webpack_require__("5oOZ");
function injectStyle (ssrContext) {
  __webpack_require__("178r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8cd51d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HP+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('bz-view',{attrs:{"articleIds":_vm.articleIds}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
function injectStyle (ssrContext) {
  __webpack_require__("qYHz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IHIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__("Kz7p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("sqiO");
//
//
//
//
//
//
//
//
//
//
//





var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["g" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_localization__ = __webpack_require__("ml/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_bz_tree__ = __webpack_require__("LwVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_editor__ = __webpack_require__("/+mb");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    localization: __WEBPACK_IMPORTED_MODULE_2__modules_localization__["a" /* default */],
    bzTree: __WEBPACK_IMPORTED_MODULE_3__store_modules_bz_tree__["a" /* default */],
    editor: __WEBPACK_IMPORTED_MODULE_4__store_modules_editor__["a" /* default */]
  }
}));

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
function injectStyle (ssrContext) {
  __webpack_require__("eH2t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
function injectStyle (ssrContext) {
  __webpack_require__("mb8U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JKUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LjgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-paragraph",class:_vm.columnsClass()},[(_vm.localized('title'))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",style:(_vm.titleStyle())},[_c(_vm.titleTag(),{tag:"component",domProps:{"textContent":_vm._s(_vm.localized('title'))}})],1)]):_vm._e(),_c('div',{staticClass:"row"},_vm._l((_vm.children),function(child){return _c(_vm.tagByModel(child[0]),{key:_vm.compoundKey.apply(void 0, child),tag:"component",attrs:{"id":child[1]}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LwVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var state = function state() {
  return {
    config: {},
    data: {}
  };
};

function rebuildParentsCash(state) {
  var parentsCash = {};
  for (var type in state.data) {
    for (var item in state.data[type]) {
      for (var child in state.data[type][item].children) {
        parentsCash[state.data[type][item].children[child]] = [type, item];
      }
    }
  }
  state.parentsCash = parentsCash;
}

var mutations = {
  addLeaf: function addLeaf(state) {},
  updateData: function updateData(state, data) {
    state.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.data, data);
    rebuildParentsCash(state);
  },
  updateConfig: function updateConfig(state, config) {
    state.config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.config, config);
  }
};

var actions = {
  configure: function configure(context, config) {
    context.commit('updateConfig', config);
  },
  loadData: function loadData(context, data) {
    context.commit('updateData', data);
  }
};

var getters = {
  getLeaf: function getLeaf(state) {
    return function (type, id) {
      return state.data[type][id];
    };
  },
  getLevel: function getLevel(state) {
    return function (type, id) {
      var item = [type, id];
      var level = 0;
      while (item) {
        item = state.parentsCash[item];
        level += 1;
      }
      return level;
    };
  },
  tagByModel: function tagByModel(state) {
    return function (model) {
      return state.config.tags[model];
    };
  },
  modelByTag: function modelByTag(state) {
    return function (tag) {
      var object = state.config.tags;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).find(function (key) {
        return object[key] === tag;
      });
    };
  },
  translatableProps: function translatableProps(state) {
    return function (model) {
      return state.config.translatableProps[model];
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  namespaced: true
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1141d213_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kwmy");
function injectStyle (ssrContext) {
  __webpack_require__("Q4/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1141d213_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mwj0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NDeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__ = __webpack_require__("QxPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__ = __webpack_require__("1P+R");




__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["a" /* faTimes */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["b" /* faEdit */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["c" /* faCog */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["d" /* faParagraph */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_solid__["e" /* faPencilAlt */]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__fortawesome_vue_fontawesome___default.a);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_watcher__ = __webpack_require__("iNQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_bootstrap_scss__ = __webpack_require__("VCIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about__ = __webpack_require__("x5KR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bz_config__ = __webpack_require__("kGsC");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0__locale_watcher__["a" /* Vue */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0__locale_watcher__["a" /* Vue */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0__locale_watcher__["a" /* Vue */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_0__locale_watcher__["b" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__locale_watcher__["c" /* LocaleMixin */]],
  i18n: __WEBPACK_IMPORTED_MODULE_0__locale_watcher__["d" /* i18n */],
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__locale_watcher__["b" /* store */].dispatch('bzTree/configure', __WEBPACK_IMPORTED_MODULE_7__bz_config__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0__locale_watcher__["b" /* store */].dispatch('bzTree/loadData', __WEBPACK_IMPORTED_MODULE_6__about__["a" /* default */]);
  }
});

/***/ }),

/***/ "NthP":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>Appbooster, Бэкенд разработчик, 2020-</li>\n<li>MDL Talent Hub, Разработчик, 2017-2020</li>\n<li>DataArt, Разработчик, 2015–2016</li>\n<li>SPBTV, Разработчик, 2012–2013</li>\n<li>First Line Software, Разработчик, 2012</li>\n<li>Transas, C++ разработчик, 2010</li>\n</ul>\n";

/***/ }),

/***/ "NyFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var translations = {
  en: {
    name: 'English',
    shortName: 'En',
    navbar: {
      language: 'Language'
    },
    routes: {
      about: 'About',
      blog: 'Blog'
    },
    forms: {
      buttons: {
        save: 'Save'
      }
    }
  },
  ru: {
    forms: {
      buttons: {
        save: 'Сохранить'
      }
    },
    name: 'Русский',
    shortName: 'Ру',
    navbar: {
      language: 'Язык'
    },
    routes: {
      about: 'Об авторе',
      blog: 'Блог'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (translations);

/***/ }),

/***/ "OA+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__ = __webpack_require__("4rkS");
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bz-text',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__["a" /* default */]],
  computed: {
    customClass: function customClass() {
      var textAlign = this.bzData && this.bzData.style && this.bzData.style.textAlign;
      var result = '';
      for (var k in textAlign) {
        result = result + ' ' + k + '-' + textAlign[k];
      }
      return result;
    }
  }
});

/***/ }),

/***/ "OFOS":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>Bachelor degree, Computer Science,\n<a href=\"https://en.smtu.ru\">Saint-Petersburg State Marine University</a></li>\n<li>Masters degree, Computer Science,\n<a href=\"https://en.smtu.ru\">Saint-Petersburg State Marine University</a></li>\n</ul>\n";

/***/ }),

/***/ "P7j2":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>Бакалавр выч. техники, <a href=\"https://www.smtu.ru/\">СПбГМТУ</a></li>\n<li>Магистр выч. техники, <a href=\"https://www.smtu.ru/\">СПбГМТУ</a></li>\n</ul>\n";

/***/ }),

/***/ "PAa6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PKje":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"gtd-oriented-couching-platform\">GTD oriented couching platform</h4>\n<p><strong>Customer:</strong> American corporate training and leadership development company</p>\n<p><strong>Description:</strong> Couching service that was based on book methodology for successfully solving any individual behavior ​challenge, at work or at home</p>\n<p><strong>Languages:</strong> Ruby</p>\n<p><strong>Tools:</strong> Ruby on Rails, RSpec, MySQL, Capistrano, Carrierwave, Haml, Slim, JavaScript</p>\n<p><strong>Position:</strong> Software Developer</p>\n<p><strong>Role:</strong></p>\n<ul>\n<li>Wrote and tested several step-by-step quiz environments</li>\n<li>Created user “current success” administration tool</li>\n<li>Made several client customizations</li>\n</ul>\n";

/***/ }),

/***/ "Q4/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QUmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__("IHIz");
function injectStyle (ssrContext) {
  __webpack_require__("Mwj0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SsFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__ = __webpack_require__("euDc");
function injectStyle (ssrContext) {
  __webpack_require__("l6Tx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TSEB":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"hospitality-scraping-solution\">Hospitality Scraping Solution</h4>\n<p><strong>Customer:</strong> International hospitality company</p>\n<p><strong>Description:</strong> Multiple parts application which main goal is to control customers partners. Contains of scrape engine receiving information about 400 companies websites and apis, scheduler part scheduling scraping sessions, Sidekiq engine running scheduled jobs and writing raw result data to RabbitMQ, AMQP receiving part parsing and storing result data to Postgresql and Rails API part delivering prepared results to frontend AngularJS application. Application also write stats and contains authentication and authorization logics.</p>\n<p><strong>Platform:</strong> AWS</p>\n<p><strong>Languages:</strong>​ Ruby, JavaScript</p>\n<p><strong>Tools:</strong> PostgreSQL, Ruby on Rails 4.2, Sidekiq(Redis), RabbitMQ(AMQP), Nginx, Git, Github, Atlassian JIRA, Basecamp, Monit, Capistrano, Bash shell scripts, AngularJS, Highcharts, RSpec</p>\n<p><strong>Position:</strong> ​Software Developer</p>\n<p><strong>Role:​</strong></p>\n<ul>\n<li>Initial Ruby and Ruby on Rails development setup</li>\n<li>Initial architecture of application (Api Backend and Scraping part)</li>\n<li>Coded configuration core</li>\n<li>Coded default scraper template</li>\n<li>Sidekiq enqueueing part of application (scheduler)</li>\n<li>In cooperation with colleagues created specification for Rails JSON api</li>\n<li>Created RabbitMQ result receiving part of application</li>\n<li>Implemented most of APIs</li>\n<li>Wrote bots for several company partners</li>\n</ul>\n";

/***/ }),

/***/ "UdiT":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"amqp-transcoding-messaging-queue\">AMQP Transcoding Messaging Queue</h4>\n<p><strong>Customer:</strong> ​SPBTV</p>\n<p><strong>Description:</strong> ​Service based on Goliath and Eventmachine server delivers API and platform for enqueueing and monitoring video transcoding procedure. AMQP asynchroneous push part allows transcoding micro modules to receive transcoding tasks through AMQP protocol and spread processing power. AMQP asynchroneous pop part allows transcoder to notify server and client of its status and processing stage.</p>\n<p><strong>Languages:</strong> Ruby,  Javascript</p>\n<p><strong>Tools:</strong> ​Ruby, Ruby on Rails, Goliath, AMQP, MySQL</p>\n<p><strong>Position:</strong> Software Developer</p>\n<p><strong>Role:</strong></p>\n<ul>\n<li>Сreated specs for AMQP protocol messages</li>\n<li>Wrote asynchroneous Goliath API</li>\n<li>Wrote asynchroneous AMQP push/pop part/enqueueing</li>\n<li>Wrote gem for easy protocol verification</li>\n<li>Wrote synchroneous monitoring Rails application with views and some javascript</li>\n</ul>\n";

/***/ }),

/***/ "UkuA":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"-\">Соцсеть для коучинга продуктивности по авторской методике</h4>\n<p><strong>Заказчик:</strong> Американская коучинговая компания</p>\n<p><strong>Описание:</strong> Сервис, реализующий авторские методики обучения эффективному достижению целей по книге основателя компании.</p>\n<p><strong>Языки:</strong> Ruby</p>\n<p><strong>Инструменты:</strong> Ruby on Rails, RSpec, MySQL, Capistrano, Carrierwave, Haml, Slim, JavaScript</p>\n<p><strong>Позиция:</strong> Разработчик</p>\n<p><strong>Роль:</strong></p>\n<ul>\n<li>Реализация и тестирование раздела пошаговых игр с достижениями</li>\n<li>Создание и обновление функциональности &quot;текущие достижения&quot; пользователя</li>\n<li>Кастомизации для коучинга организаций – клиентов заказчика</li>\n</ul>\n";

/***/ }),

/***/ "V03u":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"-\">Сервисы транскодинга</h4>\n<p><strong>Заказчик:</strong> ​SPBTV</p>\n<p><strong>Описание:</strong> Набор сервисов, представлявший API для постановки видео в очередь на транскодинг и платформу для мониторинга. Представлял из себя сервис для закидывания заданий в очередь и приложение для получения, отображения и мониторинга статуса транскодинга от специализированных узлов, забравших задание из очереди.</p>\n<p><strong>Языки:</strong> Ruby, Javascript</p>\n<p><strong>Инструменты:</strong> ​Ruby, Ruby on Rails, Goliath, AMQP, MySQL, Grape</p>\n<p><strong>Позиция на проекте:</strong> Разработчик</p>\n<p><strong>Роль:</strong></p>\n<ul>\n<li>Написал спеки на json протокол для AMQP сообщений</li>\n<li>Разработал Grape API для выдачи статусов заданий</li>\n<li>Написал сервис для закидывания заданий в очередь и получения статусов из неё</li>\n<li>Реализовал гем для упрощённой верификации сообщений</li>\n<li>Подготовил Rails приложение для мониторинга</li>\n</ul>\n";

/***/ }),

/***/ "VCIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'about',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
  alias: '/about',
  meta: {
    title: 'routes.about'
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ routes: routes }));


/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__("E8q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button_close__ = __webpack_require__("NCKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("sqiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__ = __webpack_require__("5mWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__("Kz7p");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

// ObserveDom config
var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["c" /* listenOnRootMixin */]],
    components: { bBtn: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* default */], bBtnClose: __WEBPACK_IMPORTED_MODULE_2__button_button_close__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Modal Header
        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        // Modal Body
        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        // Modal
        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-' + this.size, Boolean(this.size)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* hasClass */])(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_4__utils__["f" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["g" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-padding-right') || '';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["l" /* removeAttr */])(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-margin-right') || '';
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["l" /* removeAttr */])(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(body, 'data-padding-right') || '';
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["l" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});

/***/ }),

/***/ "bNWe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-view"},_vm._l((_vm.articleList),function(article){return _c('div',{key:article.id},[(article.editing)?_c('bz-editor',{attrs:{"id":article.id}}):_c('bz-article',{attrs:{"id":article.id}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bfey":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cxWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__("/CDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("sqiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_link__ = __webpack_require__("etPs");

//
//
//
//
//
//
//
//
//
//
//






// Props needed for router links
var routerProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__link_link__["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);

// Our render function is brought in via the pagination mixin
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* paginationMixin */]],
  props: props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(link)) === 'object') {
        props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["b" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});

/***/ }),

/***/ "dCxT":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>Appbooster, Backend developer, 2020-</li>\n<li>MDL Talent Hub, Backend developer, 2017-2020</li>\n<li>DataArt, Developer, 2015–2016</li>\n<li>SPBTV, Developer, 2012–2013</li>\n<li>First Line Software, Developer, 2012</li>\n<li>Transas, C++ developer, 2010</li>\n</ul>\n";

/***/ }),

/***/ "dQIV":
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\">\n    <img class=\"img-thumbnail rounded-circle\" src='https://ru.gravatar.com/userimage/17702696/3895c416ee56759755edd2e23d4ee294.jpg?size=200'/>\n</div>\n";

/***/ }),

/***/ "eH2t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "euDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("sqiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__("Kz7p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_row__ = __webpack_require__("I7Xz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_text__ = __webpack_require__("tDPY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__ = __webpack_require__("q32r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__ = __webpack_require__("x7Qz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["h" /* formStateMixin */]],
    components: { bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_form_row__["a" /* default */], bFormText: __WEBPACK_IMPORTED_MODULE_4__form_form_text__["a" /* default */], bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__["a" /* default */], bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Label
        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        // Invalid feeback text
        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        // Valid feeback text
        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        // Form help text (description)
        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        // Build layout
        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        // Generate fieldset wrapper
        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__("GnGf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["f" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            // We only allow certain types
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control',
            // Fix missing width:100% in Bootstrap V4.beta.2
            this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                // this.ariaInvalid is null or false or 'false'
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                // User wants explicit aria-invalid=true
                return 'true';
            }
            // Most likely a string value (which could be 'true')
            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                // Update the model with the current unformated value
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});

/***/ }),

/***/ "hJiN":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"-api-\">Прокси-сервис API программ телепередач</h4>\n<p><strong>Заказчик:</strong> ​SPBTV</p>\n<p><strong>Описание:</strong> ​Кэширующий прокси-API для нескольких провайдеров программ телепередач. Изначальные xml API партнёра были крайне медленными и неудобными для использования внутри мобильных приложений. Был написан сервис, который скачивает и парсит xml, после чего складывает программы в БД, а ассеты для превью передач – в Riak, предоставляя при этом удобный JSON API.</p>\n<p><strong>Языки:</strong> Ruby</p>\n<p><strong>Инструменты:</strong> Ruby on Rails, Cron, Memcache, Riak</p>\n<p><strong>Позиция:</strong> Разработчик</p>\n<p><strong>Роль:</strong></p>\n<ul>\n<li>Backend обработка и API</li>\n<li>Администрирование Nginx/Memcache</li>\n</ul>\n";

/***/ }),

/***/ "hLhp":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"mdl\">MDL</h4>\n<p><strong>Проект:</strong> Криптовалютный проект на смарт контрактах</p>\n<p><strong>Описание:</strong> Экосистема для связи талантов (музыкантов, моделей, тату мастеров и т.д.) с заказчиками.</p>\n<p><strong>Языки:</strong>​ Ruby</p>\n<p><strong>Позиция:</strong> Developer</p>\n<p><strong>Ответственность:​</strong></p>\n<ul>\n<li>MvP</li>\n<li>Authentication</li>\n<li>Api</li>\n</ul>\n";

/***/ }),

/***/ "iNQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return i18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LocaleMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations__ = __webpack_require__("NyFj");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__store__["a"]; });





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['localization/globalLocale'],
  messages: __WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */]
});

var LocaleMixin = {
  computed: {
    locale: function locale() {
      return this.$store.getters['localization/globalLocale'];
    }
  },

  watch: {
    locale: function locale() {
      this.$i18n.locale = this.locale;
    }
  }
};



/***/ }),

/***/ "ic8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-editor row bg-faded"},[(_vm.bzData.title)?_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.localized('title')))])]):_vm._e(),_c('div',{staticClass:"components"},_vm._l((_vm.children),function(child){return _c(_vm.tagByModel(child[0]),{key:_vm.compoundKey.apply(void 0, child),tag:"component",attrs:{"id":child[1]}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jQlH":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"appbooster\">Appbooster</h4>\n<p><strong>Проект:</strong> Набор систем для мобильного маркетинга и продвижения в сторах</p>\n<p><strong>Описание:</strong> Системы для продвижения мобильных приложений</p>\n<p><strong>Языки:</strong>​ Ruby</p>\n<p><strong>Позиция:</strong> Developer</p>\n<p><strong>Ответственность:​</strong></p>\n<ul>\n<li>Разработка и поддержка апи сервисов компании</li>\n<li>Скрапинг данных из разных источников (написал несколько сервисов скрапинга)</li>\n<li>Прокси сервисы (разработал и поддерживаю балансировщики нагрузки)</li>\n</ul>\n";

/***/ }),

/***/ "jmSW":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>5+ лет работы в IT проектах различного уровня</li>\n<li>Богатый опыт работы с Ruby, Rails и сопутствующей инфраструктурой</li>\n<li>Отличные знания баз данных (PostgreSQL, Redis, RabbitMQ)</li>\n<li>Опыт фронтенд разработки Javascript (Angular, Vue)</li>\n</ul>\n";

/***/ }),

/***/ "kGsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  tags: {
    articles: 'bz-article',
    paragraphs: 'bz-paragraph',
    texts: 'bz-text'
  },
  allowedChildren: {
    articles: ['paragraphs', 'texts'],
    paragraphs: ['texts']
  },
  componentProps: {
    articles: ['title'],
    paragraphs: ['title'],
    texts: ['html', 'markdown', 'language']
  },
  translatableProps: {
    articles: ['title'],
    paragraphs: ['title'],
    texts: ['html', 'markdown']
  },
  defaultLocale: 'en'
});

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__("+6kv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__("GnGf");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["f" /* formMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["i" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        // Form Input
        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        // 'Drop Here' target
        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        // Overlay Labels
        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        // Return rendered custom file input
        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            // Instruct input to capture from camera
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true, // BS4 beta missing this
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            // Boostrap v4.beta doesn't have focus styling for custom file input
            // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
            // So we add a 'focus' class to get around these "bugs"
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                // Add focus styling for custom file input
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                // Wrapped in try in case IE < 11 craps out
                this.$refs.input.value = '';
            } catch (e) {}
            // IE < 11 doesn't support setting input.value to '' or null
            // So we use this little extra hack to reset the value, just in case
            // This also appears to work on modern browsers as well.
            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            // Always emit original event
            this.$emit('change', evt);
            // Check if special `items` prop is available on event (drop mode)
            // Can be disabled by setting no-traverse
            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_array__["b" /* from */])(filesArr));
                });
                return;
            }
            // Normal handling
            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }
            // Convert files to array
            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            // Based on http://stackoverflow.com/questions/3590058
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    // Get file
                    item.file(function (file) {
                        file.$path = path; // Inject $path to file obj
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    // Get folder contents
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                            resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_array__["b" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ "kwmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"row justify-content-md-center no-gutters"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-navbar',{attrs:{"id":"navbar","toggleable":"md","type":"light"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},_vm._l((_vm.languagesList),function(language,key){return _c('b-nav-item',{key:key,attrs:{"right":""},on:{"click":function($event){_vm.setGlobalLocale(key)}}},[_vm._v(_vm._s(language.shortName))])}))],1),_c('router-view')],1)])])]),_c('b-collapse',{staticClass:"border-left border-light col-3 col-xs-1",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"container affix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('nav',{staticClass:"navbar navbar-light navbar-expand-md justify-content-end"},[_c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'cog']}})],1)])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("bz-editor-form")])]),_c('div',{staticClass:"dropdown-divider"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item"},[_c('b-btn',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'paragraph']}})],1)],1),_c('li',{staticClass:"list-inline-item"},[_c('b-btn',[_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil-alt']}})],1)],1)])])]),_c('div',{staticClass:"dropdown-divider"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v("bz-editor-asset-manager")])])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 controls"},[_c('b-button',{attrs:{"variant":"success"}},[_vm._v(_vm._s(_vm.$t("forms.buttons.save")))])],1)])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l6Tx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUrb":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"-\">Система скраперов для туристического бизнеса</h4>\n<p><strong>Заказчик:</strong> Международная туристическая компания</p>\n<p><strong>Описание:</strong> Приложение, состоящее из микросервисов, главная цель которого – мониторинг партнёров заказчика. Состоит из скрапингового движка, получающего информацию от более чем 400 ресурсов (API и вебсайты ряда компаний), сервиса расписаний их обхода, Sidekiq раннера, непосредственно запускающего задачи скрапинга и складывающего сырые результаты работы в RabbitMQ, AMQP сервиса, получающего результаты скрапинга из RabbitMQ и раскладывающего их в базу, а так же AngularJS фронтенда, рисующего красивые графики и таблички. Фронтенд общается с Rails приложением, реализующим аутентификацию, авторизацию и API представления.</p>\n<p><strong>Платформа:</strong> AWS</p>\n<p><strong>Языки:</strong>​ Ruby, JavaScript</p>\n<p><strong>Инструменты:</strong> PostgreSQL, Ruby on Rails 4.2, Sidekiq, RabbitMQ, Nginx, Git, Atlassian JIRA, Basecamp, Monit, Capistrano, Bash, AngularJS, Highcharts, RSpec</p>\n<p><strong>Позиция:</strong> Разработчик</p>\n<p><strong>Роль:​</strong></p>\n<ul>\n<li>Запуск разработки и первоначальный DevOps</li>\n<li>Основная архитектура (API, очередей и DSL скраперов)</li>\n<li>Конфигурационное ядро</li>\n<li>Примеры различных типов скраперов и передача знаний</li>\n<li>Sidekiq enqueueing API (скедулер/расписание заданий скрапинга)</li>\n<li>Парсер результатов из RabbitMQ</li>\n<li>Реализация API</li>\n<li>Написание нескольких десятков скраперов для партнёров заказчика</li>\n</ul>\n";

/***/ }),

/***/ "mb8U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ml/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

var state = function state() {
  return {
    globalLocale: 'en',
    localsStore: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()
  };
};

var mutations = {
  setGlobalLocale: function setGlobalLocale(state, locale) {
    state.localsStore = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
    state.globalLocale = locale;
  },
  setLocale: function setLocale(state, key, locale) {
    state.localsStore[key] = locale;
  }
};

var getters = {
  globalLocale: function globalLocale(state) {
    return state.globalLocale;
  },
  getLocale: function getLocale(state) {
    return function (key) {
      return state.localsStore[key] || state.globalLocale;
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters,
  namespaced: true
});

/***/ }),

/***/ "oryz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzView_vue__ = __webpack_require__("uMzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95da43f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzView_vue__ = __webpack_require__("bNWe");
function injectStyle (ssrContext) {
  __webpack_require__("JKUr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95da43f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95da43f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p4RR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BzView__ = __webpack_require__("oryz");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      articleIds: ['title', 'top', 'bottom']
    };
  },

  components: { BzView: __WEBPACK_IMPORTED_MODULE_0__components_BzView__["a" /* default */] }
});

/***/ }),

/***/ "pROM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__ = __webpack_require__("4rkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzParagraph__ = __webpack_require__("yAmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzText__ = __webpack_require__("FlH3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fontawesome__ = __webpack_require__("NDeT");
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__["a" /* default */]],
  components: { BzParagraph: __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzParagraph__["a" /* default */], BzText: __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzText__["a" /* default */], FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fontawesome__["a" /* default */] },
  methods: {
    openEditor: function openEditor() {
      this.$store.dispatch('editor/setEditing', this.dataKey);
    }
  }
});

/***/ }),

/***/ "pX80":
/***/ (function(module, exports) {

module.exports = "<ul>\n<li>5+ years of professional expertise in the Information Technologies</li>\n<li>Rich experience in Ruby language, Ruby on Rails framework and corresponding infrastructure (used and wrote ruby gems for Riak, AMQP, Redis, MySQL, PostgreSQL, and external APIs)</li>\n<li>Solid experience with different DBs (PostgreSQL, Redis, RabbitMQ)</li>\n<li>Production experience with Javascript (Angular, Vue)</li>\n</ul>\n";

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1714b41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("HP+w");
function injectStyle (ssrContext) {
  __webpack_require__("06tE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1714b41f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1714b41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qYHz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
function injectStyle (ssrContext) {
  __webpack_require__("+fsv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r76T":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"appbooster\">Appbooster</h4>\n<p><strong>Customer:</strong> Mobile apps marketing project</p>\n<p><strong>Description:</strong> Multiple systems for mobile apps promotion and app stores optimizations</p>\n<p><strong>Languages:</strong>​ Ruby</p>\n<p><strong>Position:</strong> Backend developer</p>\n<p><strong>Role:​</strong></p>\n<ul>\n<li>Development and support of project apis</li>\n<li>Different sources data scraping</li>\n<li>Proxies (developed and support load balancers)</li>\n</ul>\n";

/***/ }),

/***/ "tZi+":
/***/ (function(module, exports) {

module.exports = "<h4 id=\"tv-guide-api-proxy\">Tv guide API proxy</h4>\n<p><strong>Customer:</strong> ​SPBTV</p>\n<p><strong>Description:</strong> ​Api caching proxy for non-uniform expensive TV-guides xml service. Receives guides from external API, ​parses it, stores to database and delivers it in JSON. Also it downloads tv-guide images and stores them to ​Riak.</p>\n<p><strong>Languages:</strong> Ruby</p>\n<p><strong>Tools:</strong> Ruby on Rails, Cron, Memcache, Riak</p>\n<p><strong>Position:</strong> Software Developer</p>\n<p><strong>Role:</strong></p>\n<ul>\n<li>Backend/api programming</li>\n<li>Nginx/Memcache administration</li>\n</ul>\n";

/***/ }),

/***/ "uMzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__ = __webpack_require__("4rkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fontawesome__ = __webpack_require__("NDeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzArticle__ = __webpack_require__("8TBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BzEditor__ = __webpack_require__("AXQC");
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BzView',
  props: ['articleIds'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__["a" /* default */]],
  components: {
    BzEditor: __WEBPACK_IMPORTED_MODULE_3__components_BzEditor__["a" /* default */], FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_1__fontawesome__["a" /* default */], BzArticle: __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzArticle__["a" /* default */]
  },
  computed: {
    articleList: function articleList() {
      var _this = this;

      return this.articleIds.map(function (id) {
        return { id: id, editing: _this.isEditing(id) };
      });
    }
  },
  methods: {
    isEditing: function isEditing(articleId) {
      var articleKey = this.compoundKey('articles', articleId);
      return this.$store.getters['editor/isEditing'](articleKey);
    }
  }
});

/***/ }),

/***/ "x5KR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  articles: {
    title: {
      children: [['paragraphs', 'title']]
    },
    top: {
      children: [['paragraphs', 'columns']]
    },
    bottom: {
      title: {
        en: 'Recent Projects',
        ru: 'Последние проекты'
      },
      children: [['paragraphs', 'recent']]
    }
  },
  paragraphs: {
    title: {
      style: {
        title: {
          textAlign: 'center'
        }
      },
      title: {
        en: 'Alexander Kostrov',
        ru: 'Александр Костров'
      },
      children: [['texts', 'title']]
    },
    columns: {
      children: [['paragraphs', 'summary'], ['paragraphs', 'education'], ['paragraphs', 'experience']]
    },
    recent: {
      children: [['paragraphs', 'appbooster'], ['paragraphs', 'mdl'], ['paragraphs', 'hospitality'], ['paragraphs', 'amqp'], ['paragraphs', 'tv'], ['paragraphs', 'backend'], ['paragraphs', 'gtd'], ['paragraphs', 'sudprof']]
    },
    summary: {
      title: {
        en: 'Summary',
        ru: 'Инфо'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [['texts', 'summary']]
    },
    education: {
      title: {
        en: 'Education',
        ru: 'Образование'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [['texts', 'education']]
    },
    experience: {
      title: {
        en: 'Work Experience',
        ru: 'Опыт работы'
      },
      style: {
        title: {
          textAlign: 'center'
        },
        columns: {
          large: 4,
          middle: 4,
          small: 12
        }
      },
      children: [['texts', 'experience']]
    },
    appbooster: {
      children: [['texts', 'appbooster']]
    },
    mdl: {
      children: [['texts', 'mdl']]
    },
    hospitality: {
      children: [['texts', 'hospitality']]
    },
    amqp: {
      children: [['texts', 'amqp']]
    },
    tv: {
      children: [['texts', 'tv']]
    },
    backend: {
      children: [['texts', 'backend']]
    },
    gtd: {
      children: [['texts', 'gtd']]
    },
    sudprof: {
      children: [['texts', 'sudprof']]
    }
  },
  texts: {
    title: {
      style: {
        textAlign: {
          h4: 'center'
        }
      },
      html: {
        en: __webpack_require__("6IIv"),
        ru: __webpack_require__("dQIV")
      }
    },
    summary: {
      style: {
        textAlign: {
          h4: 'center'
        }
      },
      html: {
        en: __webpack_require__("pX80"),
        ru: __webpack_require__("jmSW")
      }
    },
    education: {
      html: {
        en: __webpack_require__("OFOS"),
        ru: __webpack_require__("P7j2")
      }
    },
    experience: {
      html: {
        en: __webpack_require__("dCxT"),
        ru: __webpack_require__("NthP")
      }
    },
    appbooster: {
      html: {
        en: __webpack_require__("r76T"),
        ru: __webpack_require__("jQlH")
      }
    },
    mdl: {
      html: {
        en: __webpack_require__("6rxZ"),
        ru: __webpack_require__("hLhp")
      }
    },
    hospitality: {
      html: {
        en: __webpack_require__("TSEB"),
        ru: __webpack_require__("mUrb")
      }
    },
    amqp: {
      html: {
        en: __webpack_require__("UdiT"),
        ru: __webpack_require__("V03u")
      }
    },
    tv: {
      html: {
        en: __webpack_require__("tZi+"),
        ru: __webpack_require__("hJiN")
      }
    },
    backend: {
      html: {
        en: __webpack_require__("+aSA"),
        ru: __webpack_require__("EodU")
      }
    },
    gtd: {
      html: {
        en: __webpack_require__("PKje"),
        ru: __webpack_require__("UkuA")
      }
    },
    sudprof: {
      html: {
        en: __webpack_require__("5wyn"),
        ru: __webpack_require__("EHTN")
      }
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fontawesome__ = __webpack_require__("NDeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__translations__ = __webpack_require__("NyFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      routes: __WEBPACK_IMPORTED_MODULE_6__router__["b" /* routes */]
    };
  },
  components: { FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_5__fontawesome__["a" /* default */] },
  computed: {
    languagesList: function languagesList() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_7__translations__["a" /* default */]).reduce(function (obj, _ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            name = _ref2[0],
            translation = _ref2[1];

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(obj, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, name, { shortName: translation.shortName, name: translation.name }));
      }, {});
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapMutations */])('localization', ['setGlobalLocale']))
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__("KpFv");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        // These props can be inherited via the child b-progress-bar(s)
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        // This prop is not inherited by child b-progress-bar(s)
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});

/***/ }),

/***/ "yAmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzParagraph_vue__ = __webpack_require__("B27q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba631fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzParagraph_vue__ = __webpack_require__("LjgQ");
function injectStyle (ssrContext) {
  __webpack_require__("bfey")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ba631fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BzParagraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba631fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_node_modules_vue_loader_lib_selector_type_template_index_0_BzParagraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zoEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__ = __webpack_require__("4rkS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzParagraph__ = __webpack_require__("yAmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzText__ = __webpack_require__("FlH3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fontawesome__ = __webpack_require__("NDeT");
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { modelTag: 'bz-article' };
  },

  name: 'BzEditor',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_bz_tree_item__["a" /* default */]],
  components: { BzParagraph: __WEBPACK_IMPORTED_MODULE_1__components_bz_tree_BzParagraph__["a" /* default */], BzText: __WEBPACK_IMPORTED_MODULE_2__components_bz_tree_BzText__["a" /* default */], FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_3__fontawesome__["a" /* default */] }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.77ac642596a04610b09b.js